/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import {
	Classes,
	H3,
	Icon,
	Navbar,
	NavbarGroup,
	NavbarHeading,
	Alignment,
	Tooltip
} from '@blueprintjs/core';
import { useMediaQuery } from 'react-responsive'; 
import { NetworkConfigContext } from 'slykit';
import logo from '../../images/virus-pixabay.png';
import serberus from '../../images/Serberus.svg';
import { backgroundStyles } from '../../styles/styledComponentUtils';
import { useContext } from 'react';
import styled from '@emotion/styled';

/**
 * Navigation bar for Serberus.
 *
 * @returns {*}
 * @constructor
 */
export const Navigation = () => {
	const config = useContext(NetworkConfigContext);
	const BigView = ({ children }) => {
		const isDesktop = useMediaQuery({ minWidth: 1020 })
		return isDesktop ? children : null
	}
	const SmallView = ({ children }) => {
		const isTablet = useMediaQuery({ minWidth: 500, maxWidth: 1019 })
		return isTablet ? children : null
	}
	return (
		<NavBarStyled className={Classes.DARK} publicURL={config.publicURL}>
			<NavbarGroup>
				<NavbarHeading
					css={css`
						display: flex;
						align-items: center;
					`}
				>
					<Icon icon={<img alt="logo" src={logo} height={50} />} />
					<H3
						css={css`
							margin: 0 10px;
						`}
					>
						<BigView>Publication Literature Analysis and Text Interaction Platform for User Studies</BigView>
						<SmallView>PLATIPUS</SmallView>
					</H3>
				</NavbarHeading>
			</NavbarGroup>
			<NavbarGroup align={Alignment.RIGHT}>
				<Tooltip content={<center><p>Publication Literature Analysis and Text Interaction Platform for User Studies (PLATIPUS) research was supported by the DOE Office of Science through the National Virtual Biotechnology Laboratory, a consortium of DOE national laboratories focused on response to COVID-19, with funding provided by the Coronavirus CARES Act.</p></center>}>
					<Icon icon="info-sign" iconSize={Icon.SIZE_LARGE}/>
				</Tooltip>
				<Navbar.Divider />
				<Tooltip content={'Powered by Serberus'}>
					<Icon icon={<img alt="serberus" src={serberus} />} />
				</Tooltip>
			</NavbarGroup>
		</NavBarStyled>
	);
};

const NavBarStyled = styled(Navbar)`
	${({ publicURL }) => backgroundStyles(publicURL)};
	border-bottom: 1px solid rgba(255, 255, 240, 0.1);
	box-shadow: none !important;
	flex: 0 0 auto;
	padding-left: 8px;
`;
